
















































import Vue from 'vue';
import { checkRequireField, isValidEmail } from '@/util';
import {
  SuccessMessage,
  NoAccountFound,
  AuthExceptions,
  EventType
} from '@/constants'
import { resetPassword } from '@/core';

export default Vue.extend({
  name: 'ResetPasswordPanel',
  components: {
    SuccessMessage: () => import('@/components/modals/SuccessMessage.vue')
  },
  data () {
    return {
      loading: false,
      email: '',
      resetSuccessful: false,
      errors: [] as Array<object>,
      errorMessage: {} as any,
      resetSuccessfulMessage: SuccessMessage.resetSuccessful
    };
  },
  props: {
    resetFailedMessage: {
      type: String
    }
  },
  mounted () {
    this.email = this.$route.query.email ? this.$route.query.email.toString() : '';
    const isDisabled = this.$route.query.disabled ? !!this.$route.query.email.toString() : false;
    this.email && isDisabled && this.errors.push(NoAccountFound());
    this.resetFailedMessage && this.email && !isDisabled && this.errors.push({ message: this.resetFailedMessage });
  },
  methods: {
    resetPassword () {
      this.errors = [];
      this.validateData(this.email, 'Email');
      if (!this.errors.length) {
        this.submitData();
      }
    },
    validateData (data: string, field: string) {
      let message = checkRequireField(data, field);
      if (!message && !isValidEmail(data)) {
        message = 'Please enter a valid email address.';
      }
      if (message) {
        this.errors.push({ message });
      }
    },
    async submitData () {
      this.loading = true;
      try {
        const data = await resetPassword(this.email);
        this.handleSuccess(data);
      } catch (error) {
        this.handleFailure(error);
      }
    },
    backToLoginPage () {
      this.email = '';
      this.errors = [];
      Object.keys(this.$route.query).length && this.$router.push({ query: {} })
      this.$emit(EventType.LOGIN_PAGE);
    },
    handleSuccess (data: object) {
      this.resetSuccessful = true;
      this.loading = false;
    },
    handleFailure (user: any) {
      if (user.name.includes(AuthExceptions.UserNotFoundException) || user.name.includes(AuthExceptions.NotAuthorizedException)) {
        this.errorMessage = NoAccountFound();
      }
      this.errors.push(this.errorMessage);
      this.resetSuccessful = false;
      this.loading = false;
    }
  }
});
